/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { StediPayer } from './StediPayer';
import {
    StediPayerFromJSON,
    StediPayerFromJSONTyped,
    StediPayerToJSON,
} from './StediPayer';

/**
 * 
 * @export
 * @interface GetStediPayers200Response
 */
export interface GetStediPayers200Response {
    /**
     * 
     * @type {Array<StediPayer>}
     * @memberof GetStediPayers200Response
     */
    data?: Array<StediPayer>;
}

/**
 * Check if a given object implements the GetStediPayers200Response interface.
 */
export function instanceOfGetStediPayers200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetStediPayers200ResponseFromJSON(json: any): GetStediPayers200Response {
    return GetStediPayers200ResponseFromJSONTyped(json, false);
}

export function GetStediPayers200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStediPayers200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(StediPayerFromJSON)),
    };
}

export function GetStediPayers200ResponseToJSON(value?: GetStediPayers200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(StediPayerToJSON)),
    };
}

